/**
 * This function maps any elastic search autocomplete options
 * to autocomplete options, useful for the SearchAutocomplete component.
 *
 * @param option -
 * The elastic search autocomplete option.
 * @param attribute -
 * The autocomplete attribute that belongs to the option.
 * @param query -
 * The current query from the searchbar.
 *
 * @returns {AutocompleteOption}
 * The mapped option, with updated _score and highlight properties.
 */
export default function mapAutocompleteOption(option, attribute) {
  let query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  const {
    text,
    _score: score = 0
  } = option;
  let highlighted = text;
  let newScore = score || 0;
  query.split(' ').filter(queryPart => queryPart.length > 0).forEach(queryPart => {
    // Remove any special character from the queryPart.
    const cleanQueryPart = queryPart.replaceAll(/[^\w\d]/gi, '');

    // Replace all query parts within the text, that
    // aren't already highlighted, with highlighted strings.
    const re = new RegExp("(".concat(cleanQueryPart, ")(?![^<]*>|[^<>]*<)"), 'gi');
    highlighted = highlighted.replaceAll(re, "<em>".concat(cleanQueryPart, "</em>"));

    // Give matches a leg up in the sorting.
    if (re.test(text)) {
      newScore *= 2;
    }
  });
  return {
    ...option,
    _score: newScore,
    highlight: {
      [attribute]: [highlighted]
    }
  };
}